import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { FadeUp } from "../components/Reveal";
import { NoteEyebrow } from "../components/NoteEyebrow";
import { EmSwash } from "../components/EmSwash";
import { ContactForm } from "../components/contact/ContactForm";
import { SEO } from "../lib/SEO";
import { LitGround } from "../components/PaperLight";

/**
 * Contact — public contact page (nav "Contact", footer "Contact us").
 *
 * One form does both jobs: message → category inbox via `POST /api/contact`,
 * and/or the launch waitlist via the checked-by-default "tell me when
 * campaigns go live" box. Editorial 2-column body: framing copy left,
 * form card right, doodle bookends.
 */
export default function Contact() {
  return (
    <main data-testid="contact-page" className="bg-sand">
      <SEO
        title="Contact — My Rich Aunt"
        description="Get in touch with My Rich Aunt, or ask us to tell you when verified student campaigns go live. For students, donors, partners, and board or investor inquiries."
        path="/contact"
      />
      <Navbar onStart={() => (window.location.href = "/")} primaryLabel="Back to home" />

      {/* Masthead */}
      <LitGround>
      <section className="mx-auto max-w-7xl px-6 pt-32 lg:px-8 lg:pt-48">
        <FadeUp>
          <h1
            data-testid="contact-headline"
            className="max-w-4xl font-serif text-[3.5rem] lg:text-[5.5rem] leading-[0.95] tracking-tight text-ink"
          >
            Say <EmSwash>hello.</EmSwash>
          </h1>
        </FadeUp>
        <div className="mt-8 h-px w-full bg-ink/15" />
      </section>
      </LitGround>

      {/* Copy + the one form */}
      <section className="mx-auto max-w-7xl px-6 pb-4 pt-10 lg:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.15fr] lg:gap-16">
          <FadeUp>
            <p className="max-w-md font-serif text-3xl leading-relaxed text-ink" data-testid="contact-lead">
              Whether you're a student thinking about a campaign, a donor wanting to back one, a school hoping to partner with us, or a board member with a question, this note lands with us.
            </p>
            <p className="mt-8 max-w-md text-base leading-relaxed text-olive" data-testid="contact-reply-note">
              We read every note and reply as soon as we can. Prefer email?{" "}
              <a
                href="mailto:hellofrom@myrichaunt.org"
                className="font-semibold text-ink underline decoration-tangerine decoration-2 underline-offset-4 hover:text-tangerine"
                data-testid="contact-direct-email"
              >
                hellofrom@myrichaunt.org
              </a>
              .
            </p>

            <div className="mt-16 max-w-md border-t border-ink/15 pt-10" data-testid="contact-launch-note">
              <NoteEyebrow accent="bg-tangerine">launching soon</NoteEyebrow>
              <p className="mt-5 font-serif text-3xl leading-snug text-ink">
                Verified student campaigns open soon with a first cohort.
              </p>
              <p className="mt-4 text-base leading-relaxed text-olive">
                Leave the box ticked and we'll write the moment they go live. Donations are already open as founding donations to the general fund.
              </p>
            </div>
          </FadeUp>

          <FadeUp delay={0.08}>
            <ContactForm />
          </FadeUp>
        </div>
      </section>


      <Footer />
    </main>
  );
}
